import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ee92e5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Invitations ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_spaces_group = _resolveComponent("spaces-group")!
  const _component_spaces_user_transition = _resolveComponent("spaces-user-transition")!
  const _component_app_skeleton_contact = _resolveComponent("app-skeleton-contact")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_openBlock(), _createBlock(_component_app_item_wrapper, null, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    control: _withCtx(() => [
      (_ctx.invitations.length > 10)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAll = !_ctx.showAll)),
            class: "more-link"
          }, _toDisplayString(_ctx.showAll ? _ctx.$localize('drive.section.button.less_all') : _ctx.$localize('drive.section.button.view_all')), 1))
        : _createCommentVNode("", true)
    ]),
    main: _withCtx(() => [
      (!_ctx.skeleton)
        ? (_openBlock(), _createBlock(_component_spaces_user_transition, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incoming, (request) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (request.user)
                    ? (_openBlock(), _createBlock(_component_spaces_user, {
                        key: request.user?.accountId,
                        user: request.user,
                        userType: _ctx.NETWORK_CONTACT_TYPES.INVITATION
                      }, null, 8, ["user", "userType"]))
                    : _createCommentVNode("", true),
                  (request.group)
                    ? (_openBlock(), _createBlock(_component_spaces_group, {
                        key: request.partner?.accountId
                  ? request.partner?.accountId + request.group?.id
                  : request.group?.id,
                        group: request.group,
                        partner: request.partner,
                        groupType: request.type === _ctx.REQUEST_TYPE.GROUP_INVITE_REQUEST
                          ? _ctx.NETWORK_CONTACT_TYPES.GROUP_INVITE_REQUEST
                          : _ctx.NETWORK_CONTACT_TYPES.IN_GROUP_REQUEST,
                        onOpenGroup: _ctx.openGroupInfo
                      }, null, 8, ["group", "partner", "groupType", "onOpenGroup"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_app_skeleton_contact),
            _createVNode(_component_app_skeleton_contact)
          ], 64))
    ]),
    _: 1
  }))
}